import { InputSkeleton } from '@/_components';
import { CardContainer, Container, FormLayout, LeftSection, StickyPageHeaderSkeletonWithButtons } from '@/_containers';

import { HeaderLoading } from './header-loading';

export default function Loading() {
  return (
    <>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} allowBack />
      <Container>
        <LeftSection>
          <HeaderLoading />

          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
              <div className="col-span-12 grid grid-cols-12 gap-6">
                <InputSkeleton className="col-span-6" />
                <InputSkeleton className="col-span-6" />
              </div>
            </FormLayout>
          </CardContainer>
        </LeftSection>
        {/* {matched?.staticData?.renderRightColumn && (
          <RightSection>
            <ProfileRightSectionLoading />
          </RightSection>
        )} */}
      </Container>
    </>
  );
}
